import { connect } from 'react-redux';
import { Header } from './Header';
import { logout } from 'store/state/app/actions';

const mapDispatchToProps = {
  onLogout: logout,
};

export default connect(null, mapDispatchToProps)(Header);
